import React, { useEffect } from "react";
import { NotesModalConsts } from "./constants";
import InputField from "../../../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../../../enums/InputFieldAttributesEnums";
import { message, Modal } from "antd";
import { useFormContext } from "react-hook-form";
import QuarryDatabaseService from "../../../../../services/quarryDatabase.service";
import TNLoader from "../../../../../reusable-components/TNLoader";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "../../../../../constants/QueryKeys";
import TNButton from "../../../../../reusable-components/TNButton";
import {
  ButtonSize,
  ButtonType,
  CommonButtonTexts,
} from "../../../../../enums/ButtonAttributesEnums";

interface NotesModalProps {
  isOpen: boolean;
  handleClose: () => void;
  quarryId: string;
  notesValue: string;
}

const NotesModal = ({
  isOpen,
  handleClose,
  quarryId,
  notesValue,
}: NotesModalProps) => {
  const { getValues, setValue, reset } = useFormContext();
  const queryClient = useQueryClient();
  const { TITLE, WIDTH, NOTES_FIELD_NAME, SAVE_SUCCESS } = NotesModalConsts;
  const { UpdateQuarryNotes } = QuarryDatabaseService();
  const { mutateAsync, isPending } = UpdateQuarryNotes({
    quarryId: quarryId,
  });

  const handleCancel = () => {
    handleClose();
    reset();
  };

  const handleSaveNotes = async () => {
    const payload = getValues(NOTES_FIELD_NAME);
    await mutateAsync(payload, {
      onSuccess: () => {
        queryClient.invalidateQueries([
          QueryKeys.FETCH_QUARRY_HEADER_DETAILS_KEY,
        ]);
        handleCancel();
      },
    });
  };

  useEffect(() => {
    setValue(NOTES_FIELD_NAME, notesValue);
  }, [notesValue]);

  return (
    <>
      <TNLoader isLoading={isPending} />
      <Modal
        visible={isOpen}
        title={TITLE}
        width={WIDTH}
        footer={
          <TNButton
            text={CommonButtonTexts.SAVE}
            type={ButtonType.PRIMARY}
            size={ButtonSize.MEDIUM}
            onClick={() => {
              handleSaveNotes();
            }}
          />
        }
        onCancel={handleCancel}
        mask={false}
        maskClosable={false}
        destroyOnClose
      >
        <InputField
          type={InputfieldTypes.TEXT_AREA}
          name={NOTES_FIELD_NAME}
          maxLength={500}
          textAreaRows={6}
          noResize={true}
        />
      </Modal>
    </>
  );
};

export default NotesModal;
